module.exports = __webpack_public_path__ + "img/Entstehungsbrand.df36d455.svg";